import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  imports: [MatRippleModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatDialogModule,CdkStepperModule],
  exports: [MatRippleModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatDialogModule,CdkStepperModule],
})
export class MaterialModule {}
